import { createTypeGuard, getAssetEpisodeIndication } from '../asset';

import { RentalAsset, RentalEpisodeAsset, RentalMovieAsset } from './types';

export const isRentalEpisodeAsset = createTypeGuard<RentalAsset, RentalEpisodeAsset>('episode');
export const isRentalMovieAsset = createTypeGuard<RentalAsset, RentalMovieAsset>('movie');

export function getRentalAssetEpisodeIndication(asset: RentalAsset) {
  if (isRentalEpisodeAsset(asset)) {
    return getAssetEpisodeIndication(asset);
  }
}
